import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CHECKOUTS_FEATURE_GROUP } from './group';

export const CHECKOUTS_FEATURES = {
  ACCESS: {
    guid: '1aa51e03-0388-45c9-9230-46e6d5540001',
    name: 'checkouts:access',
    description: 'Access the Checkouts app',
    action: 'read',
    product: 'app',
    parentGuid: CHECKOUTS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CHECKOUTS_FEATURE_GROUP } from './group';

export const CHECKOUTS_MODULE: FeatureModule = {
  product: 'app',
  groups: [CHECKOUTS_FEATURE_GROUP],
  features: featureList(CHECKOUTS_FEATURES),
};
